import { render } from "./KaimonoTop.vue?vue&type=template&id=3d33ee5a"
import script from "./KaimonoTop.vue?vue&type=script&lang=js"
export * from "./KaimonoTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__